/**
 * Mount the app-update checker for as long as the app shell is mounted.
 * Call once, in the authenticated layout; a second mount would double the polling.
 */
import { useEffect } from 'react';

import { startAppUpdateChecker } from './appUpdateChecker';

/** Run `startAppUpdateChecker` for the lifetime of the calling component. */
export function useAppUpdateChecker(): void {
  // Start/stop is a clean pair, so an `<Activity>` re-show or a StrictMode
  // double mount restarts it rather than stacking a second instance.
  useEffect(() => startAppUpdateChecker(), []);
}
